import Lottie from "lottie-react";
import SuccessAnimation from "../../../../shared/lottie/success.json";

interface VendorEmailPlaceHolderProps {
  organizationName?: string;
}

const VendorEmailPlaceHolder = ({ organizationName }: VendorEmailPlaceHolderProps) => {

  return (
    <div className="w-full h-full flex flex-col">
      <div className="w-full h-full bg-white flex items-center px-24 gap-32 rounded-lg">
        <div className="grow w-full flex flex-col items-start justify-center gap-4">
          <h4 className="text-4xl font-semibold leading-[60px]">
            <div>Responses Received </div>
            <div>{organizationName ? ` by ${organizationName}` : ''}!</div>
          </h4>
          <h6 className="text-md text-[#71717A]">
            Your submission is under review. You will be contacted if additional details are needed.
          </h6>
        </div>
        <div className="grow w-full flex flex-col items-start justify-center gap-4">
          <Lottie animationData={SuccessAnimation} loop={false} />
        </div>
      </div>
    </div>
  );
};

export default VendorEmailPlaceHolder;
